import ExpertList from '@/views/expert/ExpertList.vue'

export default [
    {
        // 附近门店列表
        path: '/expert/list',
        name: 'ExpertList',
        component: ExpertList
    }
]
